import React from 'react'
import cn from 'classnames'
import { Trans } from '@mc/i18n'
import { trackFaqLinkClick } from '../../events/pageClick'
import { useCertificatePriceLimit } from '../../hooks/useCertificatePriceLimit'
import {
  i18nInstance,
  BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE,
} from '../../i18n'

const t = i18nInstance.getFixedT(
  null,
  BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE,
)

const AnswerComponent = ({ kind }: { kind: 'certificates' | 'toolkit' }) => {
  const maxPrice = useCertificatePriceLimit()

  return (
    <p className='mc-opacity--hinted'>
      <Trans
        i18nKey={`faq.general.${kind}.answer`}
        ns={BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}
        components={{
          bold: <span className='mc-text--bold' />,
          p: <p className={cn({ 'mc-mb-3': kind === 'toolkit' })} />,
          separator: <span className='mc-mb-5 d-block' />,
          br: <br />,
          certificatesList: <CertificatesList />,
        }}
        values={{ maxPrice }}
      />
    </p>
  )
}

const COMMON_UTM_PARAMS =
  'utm_source=checkout&utm_medium=faq&utm_campaign=prcng-698_v1'

const CertificatesList = () => {
  const handleClick = (action: string) => {
    trackFaqLinkClick({ action: `${FAQ_UUID}:${action}` })
  }

  return (
    <ul className='list-styled mc-mx-4 mc-px-4'>
      <li>
        <a
          href={`/certificates/leadership-and-decision-making-under-pressure?${COMMON_UTM_PARAMS}&utm_content=navy_seals`}
          target='_blank'
          rel='noopener noreferrer'
          className='mc-text--link'
          onClick={() => handleClick('navy_seals')}
        >
          {t('faq.certificatesList.navySeals')}
        </a>
      </li>
      <li>
        <a
          href={`/certificates/breakthrough-innovation-strategy-from-bold-idea-to-business-impact?${COMMON_UTM_PARAMS}&utm_content=google_moonshot`}
          target='_blank'
          rel='noopener noreferrer'
          className='mc-text--link'
          onClick={() => handleClick('google_moonshot')}
        >
          {t('faq.certificatesList.googleMoonshot')}
        </a>
      </li>
    </ul>
  )
}

export const FAQ_UUID = 'What Are Certificates'

export const certificatesIncludedFAQ = ({
  hide = true,
}: {
  hide?: boolean
} = {}) => [
  {
    uuid: FAQ_UUID,
    label: t(
      `${BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}:faq.general.certificates.question`,
    ),
    title: t(
      `${BUNDLING_TOOLKIT_AND_CERTIFICATES_I18N_NAMESPACE}:faq.general.certificates.question`,
    ),
    answer: <AnswerComponent kind='certificates' />,
    hide,
  },
]
